// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"218a2c68","179":"ce3b0fb5","604":"6a0e29db","892":"7d488795"}[chunkId] + ".js";
};